import React, { useContext } from 'react';
import styled from 'styled-components';
import { Link } from '@reach/router';
import LogoSmLight from 'assets/logo-neuvana-dark-x1.png';
import { useSelector } from 'react-redux';
import { selectAdminStatus } from 'state/user/UserSelectors';
import { AppState } from 'state/store';
import { AdminStatus } from 'state/user/UserTypes';
import { AdminViewModeContext } from 'state/AdminViewModeContext';

const NavLogo: React.FC = (): JSX.Element => {
   const isActiveAdmin: boolean = useSelector((state: AppState) => selectAdminStatus(state) === AdminStatus.active);
   const { viewingAs } = useContext(AdminViewModeContext);
   let linkDestination: '/waveforms' | '/profile' = isActiveAdmin ? '/waveforms' : '/profile';
   if (viewingAs === 'customer') {
      linkDestination = '/profile';
   }
   return (
      <NavLogoContainer to={linkDestination}>
         <img src={LogoSmLight} alt="Neuvana small logo" height={50} width={50} />
         <NavLogoText>Neuvana</NavLogoText>
      </NavLogoContainer>
   );
};

export default NavLogo;

const NavLogoContainer = styled(Link)`
   display: flex;
   justify-content: flex-start;
   align-items: center;
   flex-direction: row;
   text-decoration: none;
`;

const NavLogoText = styled.span`
   font-weight: 400;
   font-size: 1.5em;
   margin-left: 7px;

   @media only screen and (max-width: 615px) {
      display: none;
   }
`;
